import { render, staticRenderFns } from "./games.vue?vue&type=template&id=0c681a40&scoped=true"
import script from "./games.vue?vue&type=script&lang=js"
export * from "./games.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c681a40",
  null
  
)

export default component.exports